import { render, staticRenderFns } from "./FoodDiaryDaySkeleton.vue?vue&type=template&id=761010a1&scoped=true"
import script from "./FoodDiaryDaySkeleton.vue?vue&type=script&lang=js"
export * from "./FoodDiaryDaySkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761010a1",
  null
  
)

export default component.exports